"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressType = void 0;
var ProgressType;
(function (ProgressType) {
    ProgressType["dot"] = "dot";
    ProgressType["number"] = "number";
})(ProgressType || (exports.ProgressType = ProgressType = {}));
